import PropTypes from 'prop-types';
import React, { useEffect, useState, useCallback } from 'react';
import TeamLeaderboardView from './team_leaderboard_view';
import withV2HealthCheck from '../../with_v2_health_check';
import { currentPitchingStatus, fetchComparativePromoterAnalytics } from './api';

function TeamLeaderboard({ v1ClientFirmId, unlockPitchesUrl }) {
  const pitchingStatus = currentPitchingStatus(); // "active" | "paused"

  const [currentState, setCurrentState] = useState({
    status: 'loading', // "loading" | "success" | "success::expanded" | "error"
    payload: { pitchingStatus },
  });

  const toggleExpanded = useCallback(() => {
    setCurrentState((state) => {
      switch (state.status) {
        case 'success':
          return { ...state, status: 'success::expanded' };
        case 'success::expanded':
          return { ...state, status: 'success' };
        default:
          return state;
      }
    });
  }, []);

  const fetchData = useCallback(async () => {
    try {
      setCurrentState({ status: 'loading', payload: { pitchingStatus } });

      const { previous, current } = await fetchComparativePromoterAnalytics({
        v1ClientFirmId,
        currentPeriod: 'this_rolling_month',
        previousPeriod: 'previous_rolling_month',
      });

      // Set success state with data payload
      setCurrentState({
        status: 'success',
        payload: {
          rawPreviousData: previous,
          rawCurrentData: current,
          unlockPitchesUrl,
          pitchingStatus,
        },
      });
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Failed to fetch data:', error);

      // Set error state with error message
      setCurrentState({
        status: 'error',
        payload: {
          message: 'Failed to load team leaderboard data. Please check your connection and try again.',
          originalError: error.message,
        },
      });
    }
  }, [v1ClientFirmId, unlockPitchesUrl, pitchingStatus]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const handleRetry = useCallback(() => {
    fetchData();
  }, [fetchData]);

  return <TeamLeaderboardView currentState={currentState} onRetry={handleRetry} onToggleExpanded={toggleExpanded} />;
}

TeamLeaderboard.propTypes = {
  v1ClientFirmId: PropTypes.number.isRequired,
  unlockPitchesUrl: PropTypes.string.isRequired,
};

export default withV2HealthCheck(TeamLeaderboard, null);
